// ---- Water-landing splash (gravity plan) ------------------------------------
// A couple of expanding, fading rings on the water surface where a falling
// body came down. Client-only cosmetic — the server just skips fall damage on
// wet landings; nothing rides the wire. Rings self-expire in under a second,
// so there's nothing to clean up on a world swap. DOM-free but THREE-using —
// client bundle only (game.ts wires init/update; never imported server-side).

import * as THREE from "three";

let scene: THREE.Scene | null = null;

type Ring = { mesh: THREE.Mesh; t: number; dur: number };
const rings: Ring[] = [];

// One shared unit ring, scaled per instance; materials are per-ring (they fade
// independently) and disposed on expiry. Plain unlit material by design — a
// transient water highlight, not a toon-lit surface.
const GEO = new THREE.RingGeometry(0.55, 0.78, 24);

export function initSplash(s: THREE.Scene): void {
  scene = s;
}

/** Spawn the splash at the water surface (y = the map's water level). */
export function spawnSplash(x: number, y: number, z: number): void {
  if (!scene) return;
  for (let i = 0; i < 2; i++) {
    const mat = new THREE.MeshBasicMaterial({
      color: 0xdff3ff, transparent: true, opacity: 0.8,
      side: THREE.DoubleSide, depthWrite: false,
    });
    const mesh = new THREE.Mesh(GEO, mat);
    mesh.rotation.x = -Math.PI / 2;
    mesh.position.set(x, y + 0.06 + i * 0.03, z);
    mesh.scale.setScalar(0.45 + i * 0.35);
    scene.add(mesh);
    rings.push({ mesh, t: 0, dur: 0.5 + i * 0.22 });
  }
}

/** Advance + fade every live ring. Call once per frame. */
export function updateSplashes(dt: number): void {
  for (let i = rings.length - 1; i >= 0; i--) {
    const r = rings[i]!;
    r.t += dt;
    const k = r.t / r.dur;
    if (k >= 1) {
      scene?.remove(r.mesh);
      (r.mesh.material as THREE.Material).dispose();
      rings.splice(i, 1);
      continue;
    }
    r.mesh.scale.setScalar(r.mesh.scale.x + dt * 3.4);
    (r.mesh.material as THREE.MeshBasicMaterial).opacity = 0.8 * (1 - k);
  }
}
